import React, { useState, Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import Autocomplete from '@material-ui/lab/Autocomplete';
import DeleteIcon from '@material-ui/icons/Delete';
import { request } from 'utilities/graph';
import Issue from 'views/Admin/DeliveryDiary/Issue';
import {
  createIssue,
  createIssueComment,
  updateIssue,
  deleteIssue,
  deleteIssueComment,
} from 'graphql/mutations';
import { getIssue } from 'graphql/queries';
import cache from 'utilities/cache';
import { issueStatus as allIssueStatus, issueTypes as allIssueTypes } from '@silvergatedelivery/constants';
import moment from 'moment-timezone';
import { TIME_ZONE } from '@silvergatedelivery/constants';
import PhoneCheckTable from './PhoneCheckTable';

export default function SocialWorkerDiaryEditButton({
  mode = 'edit',
  elders,
  defaultElder,
  item: inIssue,
  onUpdate,
  disabled = false,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [issue, setIssue] = useState(inIssue);
  const [issueDescription, setIssueDescription] = useState('');
  const [commentText, setCommentText] = useState('');
  const [issueStatus, setIssueStatus] = useState(allIssueStatus[0].value);
  const [issueType, setIssueType] = useState(allIssueTypes[0].value);
  const [elder, setElder] = useState(defaultElder);
  const [issueDateTime, setIssueDateTime] = useState(moment().tz(TIME_ZONE).toISOString());
  const [issueUpdated, setIssueUpdated] = useState(false);

  useEffect(() => {
    if (open) {
      setIssueDateTime(moment().tz(TIME_ZONE).toISOString());
    }
  }, [open]);

  useEffect(() => {
    if (!inIssue) return;

    if (inIssue.elderId) {
      const elder = elders.find((e) => e.id === inIssue.elderId);
      setElder(elder);
    }

    setIssue(inIssue);
    setIssueStatus(inIssue.status);
    setIssueType(inIssue.type);
    if (inIssue.executedAt) {
      setIssueDateTime(inIssue.executedAt);
    } else {
      setIssueDateTime(inIssue.createdAt);
    }
  }, [inIssue, elders]);

  const handleCreateIssue = async () => {
    setIsLoading(true);
    const username = cache.get('app:username');
    const userName = cache.get('app:userName');
    if (!elder) {
      return;
    }

    const issueInput = {
      priority: 1,
      status: issueStatus,
      type: issueType,
      reportedBy: userName,
      county: elder.county,
      orderId: undefined,
      elderId: elder.id,
      clientId: elder.clientId,
      deliveryStaffId: undefined,
      deliveryStaffOrderId: undefined,
      summary: issueType,
      executedAt: issueDateTime,
      createdBy: username,
      updatedBy: username,
      expirationUnixTime: Math.round(Date.now() / 1000) + 365 * 86400 * 3, // TODO: 存三年？
      description: issueDescription,
    };

    const { data: { createIssue: updatedIssue } } = await request(createIssue, { input: issueInput });

    if (commentText) {
      const now = new Date().toISOString();
      const comment = {
        issueId: updatedIssue.id,
        username: userName,
        content: commentText,
        expirationUnixTime: Math.round(Date.now() / 1000) + 365 * 86400 * 3, // TODO: 存三年？
        executedAt: issueDateTime,
        createdAt: now,
        createdBy: username,
        updatedAt: now,
        updatedBy: username,
      };

      await request(createIssueComment, { input: comment });
      const { data: { getIssue: updatedIssueWithComment } } =await request(getIssue, { id: updatedIssue.id });
      onUpdate(updatedIssueWithComment);
    } else {
      onUpdate(updatedIssue);
    }

    setIsLoading(false);
    handleClose();
  };

  const handleUpdateIssue = async () => {
    setIsLoading(true);
    const username = cache.get('app:username');
    const userName = cache.get('app:userName');
    const now = new Date().toISOString();

    let content = commentText || '';
    if (issueStatus !== issue.status) {
      const oldstatus = allIssueStatus.find((item)=>item.value === issue.status);
      const newStatus = allIssueStatus.find((item)=>item.value === issueStatus);
      if (content) {
        content = `${content} (狀態：${oldstatus.label} => ${newStatus.label})`;
      } else {
        content = `狀態：${oldstatus.label} => ${newStatus.label}`;
      }
    }
    if (content) {
      const comment = {
        issueId: issue.id,
        username: userName,
        content,
        expirationUnixTime: Math.round(Date.now() / 1000) + 365 * 86400 * 3, // TODO: 存三年？
        executedAt: issueDateTime,
        createdAt: now,
        createdBy: username,
        updatedAt: now,
        updatedBy: username,
      };

      await request(createIssueComment, { input: comment });
    }
    if (issueStatus !== issue.status) {
      const now = new Date().toISOString();
      const updatedIssue = {
        id: issue.id,
        status: issueStatus,
        updatedAt: now,
        updatedBy: username,
      };
      await request(updateIssue, { input: updatedIssue });
    }
    const { data: { getIssue: updatedIssue } } =await request(getIssue, { id: issue.id });
    onUpdate(updatedIssue);
    setIsLoading(false);
    handleClose();
  };

  const handleDeleteIssue = async () => {
    if (window.confirm('確定要刪除這筆社工日誌嗎？')) {
      console.log(issue);
      await Promise.all(issue.comments.items.map((comment) => {
        const input = {
          id: comment.id,
        };
        return request(deleteIssueComment, { input });
      }));
      const input = {
        id: issue.id,
      };
      await request(deleteIssue, { input });
      onUpdate(null);
    }
  };

  const handleClose = async () => {
    setCommentText('');
    setIssueDescription('');
    setIssueStatus(inIssue?.status || allIssueStatus[0].value);
    setIssueType(inIssue?.type || allIssueTypes[0].value);
    setElder(defaultElder);
    setOpen(false);
    if (issueUpdated) {
      const { data: { getIssue: updatedIssue } } =await request(getIssue, { id: issue.id });
      onUpdate(updatedIssue);
      setIssueUpdated(false);
    }
  };

  const tooltipTitle = () => issue ? '編輯社工日誌' : '新增社工日誌';

  return (
    <Fragment>
      <Tooltip title={tooltipTitle()} style={{}}>
        <IconButton
          data-testid={'edit'}
          aria-label={'edit'}
          onClick={() => setOpen(true)}
          disabled={disabled}
        >
          {mode === 'edit' ? <EditIcon/> : <AddIcon />}
        </IconButton>
      </Tooltip>
      {mode === 'edit' &&
      <Tooltip title={'刪除社工日誌'}>
        <IconButton
          data-testid={'delete'}
          aria-label={'delete'}
          onClick={() => {
            handleDeleteIssue();
          }}
          disabled={disabled}
        >
          <DeleteIcon />
        </IconButton>
      </Tooltip>
      }
      <Dialog
        open={open}
        maxWidth="md"
        fullWidth
        onClose={(e, reason)=>{
          if (reason === 'escapeKeyDown' || reason === 'backdropClick') return;
          handleClose();
        }}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          社工日誌
        </DialogTitle>
        <DialogContent>
          {issue ?
            <Grid container direction="column" spacing={2}>
              <Grid item>
                <Issue
                  issue={issue}
                  onAddNewComment={(commentText) => setCommentText(commentText)}
                  onUpdateIssueDateTime={(issueDateTime) => setIssueDateTime(issueDateTime)}
                  onUpdateIssueStatus={(issueStatus) => setIssueStatus(issueStatus)}
                  setIssueUpdated={(issueUpdated) => setIssueUpdated(issueUpdated)} // 從timeline修改過Issue
                />
              </Grid>
            </Grid> :
            <Grid container direction="row" spacing={2}>
              {!defaultElder &&
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <Autocomplete
                    onChange={(event, newValue) => {
                      if (typeof newValue === 'string') {
                        const existingElder = elders.find(({ name }) => name === newValue);
                        setElder(existingElder);
                      } else {
                        setElder(newValue);
                      }
                    }}
                    selectOnFocus
                    clearOnBlur
                    options={elders?.sort((a, b) => a.name.localeCompare(b.name)) || []}
                    getOptionLabel={(option) => {
                      if (typeof option === 'string') {
                        return option;
                      }
                      return option.name;
                    }}
                    renderOption={(elder) => elder.name}
                    freeSolo
                    renderInput={(params) => <TextField {...params} label='送餐對象' required />}
                  />
                </FormControl>
              </Grid>
              }
              <Grid item xs={3}>
                <FormControl fullWidth>
                  <InputLabel>狀態</InputLabel>
                  <Select
                    value={issueStatus}
                    onChange={(event) => setIssueStatus(event.target.value)}
                  >
                    {allIssueStatus.map(({ label, value }) => (
                      <MenuItem key={label} value={value} >
                        {label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={3}>
                <FormControl fullWidth>
                  <InputLabel>類別</InputLabel>
                  <Select
                    value={issueType}
                    onChange={(event) => {
                      setIssueType(event.target.value);
                      if (event.target.value === '電話問安(紀錄表)' || issueType === '電話問安(紀錄表)') {
                        setIssueDescription(event.target.value === '電話問安(紀錄表)'? '電話問安' : '');
                        setCommentText('');
                      }
                    }}
                  >
                    {allIssueTypes.map(({ label, value }) => (
                      <MenuItem key={label} value={value} >
                        {label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label='時間'
                  type="datetime-local" // format 2017-05-24T10:30
                  value={moment(issueDateTime).tz(TIME_ZONE).format('YYYY-MM-DDTHH:mm')}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  fullWidth
                  onChange={(e) => {
                    const updatedDatetime = moment.tz(e.target.value, TIME_ZONE).toISOString();
                    if (updatedDatetime) {
                      setIssueDateTime(updatedDatetime);
                    }
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  margin="dense"
                  id="diary"
                  label="追蹤事項"
                  type="text"
                  value={issueDescription}
                  fullWidth
                  required
                  multiline
                  minRows={2}
                  onChange={(e) => setIssueDescription(e.target.value) }
                />
              </Grid>
              {issueType === '電話問安(紀錄表)'? (
                <Grid item xs={12}>
                  <PhoneCheckTable onChange={setCommentText} />
                </Grid>
              ) : (
                <Grid item xs={12}>
                  <TextField
                    margin="dense"
                    id="comment"
                    label="處理筆記"
                    type="text"
                    value={commentText}
                    fullWidth
                    multiline
                    minRows={2}
                    onChange={(e) => setCommentText(e.target.value)}
                  />
                </Grid>
              )}
            </Grid>
          }
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="default" disabled={isLoading}>
            取消
          </Button>
          {issue ?
            <Button onClick={handleUpdateIssue} color="primary" variant="contained"
              disabled={isLoading || (!commentText && issue.status === issueStatus)}>
              送出
            </Button> :
            <Button onClick={handleCreateIssue} color="primary" variant="contained" disabled={isLoading || !issueDescription || !elder}>
              送出
            </Button>
          }
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}

SocialWorkerDiaryEditButton.propTypes = {
  defaultElder: PropTypes.object,
  elders: PropTypes.array,
  item: PropTypes.object,
  buttonSize: PropTypes.string,
  onUpdate: PropTypes.func,
  disabled: PropTypes.bool,
  mode: PropTypes.string,
};
